var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00039 7.61855C6.85039 7.61855 6.72539 7.56855 6.60039 7.46855L0.850391 1.81855C0.625391 1.59355 0.625391 1.24355 0.850391 1.01855C1.07539 0.793555 1.42539 0.793555 1.65039 1.01855L7.00039 6.24355L12.3504 0.968555C12.5754 0.743555 12.9254 0.743555 13.1504 0.968555C13.3754 1.19355 13.3754 1.54355 13.1504 1.76855L7.40039 7.41855C7.27539 7.54355 7.15039 7.61855 7.00039 7.61855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg81);
export default __webpack_public_path__ + "static/media/svg81.e05d058d451dd47d182a5afa38723bcc.svg";
export { ForwardRef as ReactComponent };